import { useEffect, type RefObject } from 'react';

/**
 * EAA-1817: shared outside-click + Escape close for this screen's native
 * popovers (`AppsFilterButton` and the per-column search trigger both need
 * it). `RoleMapFilterButton` (the sibling `/console/role-map` screen this
 * pattern is copied from) gets the same behaviour for free from antd's
 * `Popover` — this screen may not import antd, so the click-outside/Escape
 * wiring has to be hand-rolled once here instead of per component.
 */
export function useOutsideClick(
    ref: RefObject<HTMLElement | null>,
    open: boolean,
    onClose: () => void
): void {
    useEffect(() => {
        if (!open) return;

        function handlePointerDown(event: MouseEvent) {
            if (ref.current && !ref.current.contains(event.target as Node)) {
                onClose();
            }
        }
        function handleKeyDown(event: KeyboardEvent) {
            if (event.key === 'Escape') onClose();
        }

        document.addEventListener('mousedown', handlePointerDown);
        document.addEventListener('keydown', handleKeyDown);
        return () => {
            document.removeEventListener('mousedown', handlePointerDown);
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [open, ref, onClose]);
}
